/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type LastGroomedEnum = (typeof LastGroomedEnum)[keyof typeof LastGroomedEnum];

export const LastGroomedEnum = {
  within_four_weeks: 'within_four_weeks',
  four_to_eight_weeks_ago: 'four_to_eight_weeks_ago',
  two_to_four_months_ago: 'two_to_four_months_ago',
  over_four_months_ago: 'over_four_months_ago',
  never: 'never',
} as const;
